import { render, staticRenderFns } from "./top-user.vue?vue&type=template&id=ce62cf7a&scoped=true"
import script from "./top-user.vue?vue&type=script&lang=js"
export * from "./top-user.vue?vue&type=script&lang=js"
import style0 from "./top-user.vue?vue&type=style&index=0&id=ce62cf7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce62cf7a",
  null
  
)

export default component.exports